import { NgModule, ANALYZE_FOR_ENTRY_COMPONENTS } from '@angular/core';
import { DynamicHTMLComponent } from './dynamic-html.component';
import { DynamicHTMLOptions } from './options';
import { DynamicHTMLRenderer } from './renderer';
/**
 * Setup for DynamicHTMLDirective
 *
 * ```ts
 * @NgModule({
 *   imports: [
 *     DynamicHTMLModule.forRoot({
 *       components: [
 *         { component: MyButtonComponent, selector: 'my-button' },
 *       ]
 *     })
 *   ],
 *   declarations: [AppComponent, MyButtonComponent],
 *   bootstrap: [AppComponent]
 * })
 * export class AppModule {
 * }
 * ```
 */
var DynamicHTMLModule = (function () {
    function DynamicHTMLModule() {
    }
    DynamicHTMLModule.forRoot = function (options) {
        return {
            ngModule: DynamicHTMLModule,
            providers: [
                DynamicHTMLRenderer,
                { provide: DynamicHTMLOptions, useValue: options },
                { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: options.components, multi: true },
            ],
        };
    };
    return DynamicHTMLModule;
}());
export { DynamicHTMLModule };
DynamicHTMLModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DynamicHTMLComponent],
                exports: [DynamicHTMLComponent],
            },] },
];
/** @nocollapse */
DynamicHTMLModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/ng-dynamic/src/dynamic-html/module.js
// module id = ../../../../ng-dynamic/src/dynamic-html/module.js
// module chunks = 3